import { CoreTypography } from '@youscience/core';

import { BREADCRUMBS_PAGE_TEXT } from '@constants/breadcrumbs';

import { camelize } from '@utils/formatter';

import { Breadcrumbs } from '@components/Breadcrumbs';
import ActionButton from '@components/ActionButton';

import { sxStyles, StyledHeroSection, StyledHeroText, StyledHeroImg, StyledButtonsWrap } from './HeroSection.styles';

interface HeroSectionProps {
  breadcrumbsCurrentPage?: string;
  title: string;
  subtitle: string;
  subtitle2?: string;
  button1Name: string;
  onButton1Click: () => void;
  button2Name?: string;
  onButton2Click?: () => void;
  image: string;
}

export const HeroSection = (props: HeroSectionProps) => {
  const {
    breadcrumbsCurrentPage = BREADCRUMBS_PAGE_TEXT.ROOT,
    title,
    subtitle,
    subtitle2 = '',
    button1Name,
    onButton1Click,
    button2Name,
    onButton2Click,
    image,
  } = props;

  return (
    <StyledHeroSection>
      <StyledHeroText>
        <Breadcrumbs currentPage={breadcrumbsCurrentPage} />

        <CoreTypography sx={sxStyles.title} variant="h1">
          {title}
        </CoreTypography>

        <CoreTypography sx={sxStyles.subtitles}>{subtitle}</CoreTypography>

        <CoreTypography sx={sxStyles.subtitles}>{subtitle2}</CoreTypography>

        <StyledButtonsWrap>
          <ActionButton data-testid={`${camelize(button1Name)}Btn`} size="large" onClick={onButton1Click}>
            {button1Name}
          </ActionButton>

          {button2Name ? (
            <ActionButton
              data-testid={`${camelize(button2Name)}Btn`}
              size="large"
              variant="outlined"
              onClick={onButton2Click}
            >
              {button2Name}
            </ActionButton>
          ) : null}
        </StyledButtonsWrap>
      </StyledHeroText>

      <StyledHeroImg>
        <img src={image} alt="home-img" />
      </StyledHeroImg>
    </StyledHeroSection>
  );
};
